import classNames from "classnames";
import React from "react";
import MatchDataLayer from "../../components/MatchDataLayer";
import { Match } from "../Match/Match";
import { StyledMatchWrapper } from "./StyledMatchWrapper";
import { composeMatchStatus } from "../../utils";

export const MatchFragmentWrapper = ({
  d3Match = {},
  matchSportecId,
  params,
  containerRef,
  statsAPIMatch,
  matchPageUrl,
  position,
  hideMatchPromos,
  showClubRanks = false,
  showCompetitionStage = false,
  showRoundDetail = false,
  showGroupInformation = false,
}) => {
  const matchStatus = composeMatchStatus({
    period: statsAPIMatch?.match_status,
    delayedMatch: d3Match?.delayedMatch,
  });

  return (
    <React.Fragment key={`${matchSportecId}-match-wrapper`}>
      <StyledMatchWrapper className={classNames(params)} ref={containerRef}>
        <MatchDataLayer
          forgeMatch={d3Match}
          statsAPIMatch={statsAPIMatch}
          useEmptyClasses
          matchSportecId={matchSportecId}
          matchPageUrl={matchPageUrl}
          matchStatus={matchStatus}
          delayedMatch={d3Match?.delayedMatch}
        >
          <Match
            position={position}
            hideMatchPromos={hideMatchPromos}
            showClubRanks={showClubRanks}
            showCompetitionStage={showCompetitionStage}
            showRoundDetail={showRoundDetail}
            showGroupInformation={showGroupInformation}
          />
        </MatchDataLayer>
      </StyledMatchWrapper>
    </React.Fragment>
  );
};
